var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserPlus = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "REFER"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.8418 18.3333C2.8418 15.1083 6.05013 12.5 10.0001 12.5C10.8001 12.5 11.5751 12.6083 12.3001 12.8083M10.0001 9.99996C11.1052 9.99996 12.165 9.56097 12.9464 8.77957C13.7278 7.99817 14.1668 6.93836 14.1668 5.83329C14.1668 4.72822 13.7278 3.66842 12.9464 2.88701C12.165 2.10561 11.1052 1.66663 10.0001 1.66663C8.89506 1.66663 7.83525 2.10561 7.05385 2.88701C6.27245 3.66842 5.83346 4.72822 5.83346 5.83329C5.83346 6.93836 6.27245 7.99817 7.05385 8.77957C7.83525 9.56097 8.89506 9.99996 10.0001 9.99996Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.2415 14.9833H13.7582M14.9998 13.7666V16.2583M18.3332 15C18.3332 15.2666 18.2998 15.525 18.2332 15.775C18.1582 16.1083 18.0248 16.4333 17.8498 16.7166C17.5561 17.2104 17.1388 17.6191 16.639 17.9026C16.1393 18.186 15.5744 18.3345 14.9998 18.3333C14.1794 18.3357 13.3881 18.0293 12.7832 17.475C12.5332 17.2583 12.3165 17 12.1498 16.7166C11.8326 16.2003 11.6653 15.6059 11.6665 15C11.666 14.5621 11.7518 14.1284 11.9191 13.7237C12.0865 13.319 12.332 12.9514 12.6416 12.6417C12.9512 12.3321 13.3189 12.0866 13.7236 11.9192C14.1283 11.7519 14.562 11.6661 14.9998 11.6666C15.9832 11.6666 16.8748 12.0916 17.4748 12.775C18.0082 13.3666 18.3332 14.15 18.3332 15Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserPlus, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user_plus.596355e8.svg";
export { ForwardRef as ReactComponent };